export default __webpack_public_path__ + "assets/59d15b6e3d2cbebf8051e45942cea2c8.jpg";